export const textAndImage2023Gql = /* GraphQL */`... on landingPageContent2023_textAndImage_BlockType {
  pageTitle
  displayInHeaderQuicklinks
  id
  image {
    __typename
    ... on images_Asset {
      url
      title
      lpImageTextUncropped {
        src
        srcWebp
        srcset
        optimizedImageUrls
      }
    }
    ... on svgIcons_Asset {
      url
      title
    }
    ... on videoUploads_Asset{
      title
      videoDescription
      videoDuration
      url
      image:videoThumbnail {
        ... on images_Asset {
          lpBackgroundWide {
            srcWebp
            srcset
          }
        }
      }
    }
    ... on videos_Asset{
      title
      lpBackgroundWide {
        srcWebp
        srcset
      }
      lpImageGridLandscape {
        srcWebp
        srcset
      }
      galleryEnlarged {
        srcWebp
        srcset
      }
      image:videoThumbnail {
        ... on images_Asset {
          lpBackgroundWide {
            srcWebp
            srcset
          }
        }
      }
      videoDuration
      videoId
      videoDescription
    }
  }
  mediaMaxHeight
  mediaObjectFit
  mediaContainerBackground
  backgroundVerticalPosition
  backgroundOpacity
  description
  typeHandle
  label
  layoutStyle
  ctaButton {
    ... on ctaButton_BlockType {
      asset {
        url
      }
      entry {
        uri
      }
      custom
      buttonStyling
      buttonLabel
      ariaLabel
      openInANewWindow
    }
  }
  colors
}`;
